import { useState } from 'react';
import { Download, Loader2 } from 'lucide-react';
import api from '../../auth/api';

export default function ExportPdfButton({ entryId, entrySlug }) {
    const [exporting, setExporting] = useState(false);

    const handleExport = async () => {
        setExporting(true);
        try {
            const res = await api.get(`/wiki/entries/${entryId}/export/pdf`, {
                responseType: 'blob',
            });

            // Create download link
            const url = URL.createObjectURL(res.data);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${entrySlug || 'entry'}.html`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error('Export failed:', err);
        } finally {
            setExporting(false);
        }
    };

    return (
        <button
            onClick={handleExport}
            disabled={exporting}
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                padding: '6px 12px',
                background: 'rgba(212,175,55,0.1)',
                border: '1px solid rgba(212,175,55,0.3)',
                borderRadius: '6px',
                color: '#d4af37',
                cursor: exporting ? 'not-allowed' : 'pointer',
                fontSize: '13px',
            }}
        >
            {exporting ? <Loader2 size={16} className="animate-spin" /> : <Download size={16} />}
            {exporting ? 'Exporting...' : 'Export'}
        </button>
    );
}